import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Group, Popover, Text } from "@mantine/core";
import { memo, useCallback, useMemo } from "react";
import { LayerTypeIcon } from "../../components/LayerTypeIcon.js";
import { useClickOutside, useDisclosure } from "@mantine/hooks";
import { itemBorder, layerItemHeight, selectedItemBg } from "../../utils/style.js";
import { FormattedMessage } from "react-intl";
import { useCaptureEvent } from "../../components/StyleEditorContext.js";
import { Event } from "../../constants/events.js";
import { useAppAction, useAppSelector } from "../../hooks/redux.js";
import { changeLayerGroup, deleteLayer, getLayerGroupValues, } from "../../reducers/layersReducer.js";
export const LayerListItem = memo(({ type, id, grouped, parent, selected, rightControl, indent = 8, onClick, style }) => {
    const groups = useAppSelector(getLayerGroupValues);
    const changeGroup = useAppAction(changeLayerGroup);
    const deleteLayerAction = useAppAction(deleteLayer);
    const [opened, { close, open }] = useDisclosure(false);
    const captureEvent = useCaptureEvent();
    const ref = useClickOutside(close);
    const bg = selectedItemBg(selected);
    const handleOpen = useCallback((event) => {
        event.preventDefault();
        captureEvent(Event.OpenLayerItemRightClickMenu);
        open();
    }, [captureEvent, open]);
    const handleDelete = useCallback((event) => {
        event.preventDefault();
        captureEvent(Event.DeleteLayer);
        deleteLayerAction(id);
        close();
    }, [captureEvent, close, deleteLayerAction, id]);
    const handleChangeGroup = useCallback((from, to) => {
        captureEvent(Event.ChangeLayerGroup);
        changeGroup({ from, to, id });
        close();
    }, [captureEvent, close, changeGroup, id]);
    const groupOptions = useMemo(() => groups.filter(({ value }) => value !== parent), [groups, parent]);
    return (_jsxs(Popover, { width: 200, position: "bottom", withArrow: true, shadow: "md", opened: opened, children: [_jsx(Popover.Target, { children: _jsxs(Group, { w: "100%", h: layerItemHeight, onClick: onClick, onContextMenu: handleOpen, className: "layer-list-item", bg: bg, gap: 8, pl: indent, pr: 8, wrap: "nowrap", style: {
                        borderBottom: itemBorder,
                        borderRight: itemBorder,
                        borderLeft: itemBorder,
                        ...style,
                    }, children: [_jsx(LayerTypeIcon, { type: type }), _jsx(Text, { fz: 14, fw: 400, truncate: true, flex: 1, children: id }), _jsx(Box, { ml: "auto", children: rightControl })] }) }), _jsxs(Popover.Dropdown, { ref: ref, children: [grouped && groupOptions.length > 0 && (_jsxs(Popover, { width: 200, position: "right", withArrow: true, shadow: "md", children: [_jsx(Popover.Target, { children: _jsx(Button, { w: "100%", variant: "default", size: "xs", children: _jsx(FormattedMessage, { id: "button.changeParentGroup", defaultMessage: "Change group" }) }) }), _jsx(Popover.Dropdown, { children: groupOptions.map(({ value, label }) => (_jsx(Button, { w: "100%", variant: "default", size: "xs", onClick: () => {
                                        handleChangeGroup(parent, value);
                                    }, children: label }, value))) })] })), _jsx(Button, { w: "100%", variant: "default", size: "xs", onClick: handleDelete, children: _jsx(FormattedMessage, { id: "button.delete", defaultMessage: "Delete" }) })] })] }));
});
LayerListItem.displayName = "LayerListItem";
